module.exports = __webpack_public_path__ + "img/main_technic.84ecfb30.jpg";